export const english = {
  lang: 'en',
  data: {
    titles: {
      active_instructors: 'All instructors',
      company_information: 'Company Information',
      basic_information: 'Basic Information',
      select_courses: 'Select Course',
      upload_cv: 'Upload CV',
      and_certificates: ' and certificates',
      attachments: 'Attachments (Allowed Formats: CV - PDF/Word, Certificates - PDF/Word/Image)',
      about_instructor: 'About',
      contact_info: 'Contact info',
      reviews: 'Reviews',
      my_courses: 'My courses',
    },
    filters: {
      'templates': 'Courses',
      'regions': 'Region',
      'search': 'Search',
      'categories': 'Category',
      'reset': 'Reset'
    },
    form: {
      account_holder_name : {
        label: 'Account holder name',
        placeholder:'Account holder name',
        error: {
          required: 'Account holder name required'
        }
      },
      iban: {
        label: 'IBAN number',
        placeholder:'NO*********3000',
        error: {
          required: 'IBAN number is required',
          invalid: 'Valid IBAN number is required'
        }
      },
      first_name: {
        label: 'First name',
        hint: 'Only your first name will be visible on your instructor profile',
        placeholder:'First name',
        error: {
          required: 'First name is required',
        }
      },
      last_name: {
        label: 'Last name',
        placeholder:'Last name',
        error: {
          required: 'Last name is required',
        }
      },
      email: {
        label: 'Email',
        placeholder:'Your email address',
        error: {
          required: 'Email is required',
          invalid: 'This looks like an invalid email address. Are you sure it is spelled correctly?'
        }
      },
      confirmEmail: {
        label: 'Confirm Email',
        placeholder: 'Confirm your given email address please',
        error: {
          confirmEmail : 'Emails do not match'
        }
      },
      phone_number: {
        label: 'Phone number',
        placeholder:'Phone number',
        error: {
          required: 'Phone number is required',
          invalid: 'Phone number is invalid'
        }
      },
      date_of_birth: {
        label: 'Date of birth',
        placeholder:'YYYY-MM-DD',
        error: {
          required: 'Date of birth is required',
        }
      },
      organization_name: {
        label: 'Organization name',
        placeholder:'Organization name',
        error: {
          required: 'Organization name is required',
        }
      },
      organization_number: {
        label: 'Organization number',
        placeholder:'Organization number of your company',
        error: {
          invalid: 'The organization number is invalid',
          required: 'Organization number is required',
        }
      },
      address: {
        label: 'Address',
        placeholder:'Address',
        error: {
          required: 'Address is required',
        }
      },
      postal_code: {
        label: 'Postal code',
        placeholder:'Postal code',
        error: {
          invalid: 'The Postal code is invalid',
          required: 'Postal code is required',
        }
      },
      city: {
        label: 'City',
        placeholder:'City',
        error: {
          required: 'City is required',
        }
      },
      country: {
        label: 'Country',
        placeholder:'Country',
        error: {
          required: 'Country is required',
        }
      },
      region: {
        label: 'My Region(s)',
        placeholder:'Choose in which regions you want to offer courses',
        error: {
          required: 'Region is required',
        }
      },
      description: {
        label: 'Description',
        placeholder:'Fill in an in-depth description of yourself for your instructor profile! This will be visible to users who will book your courses.',
        error: {
          required: 'Description is required',
        }
      },
      id_verification: {
        label: 'Please upload photo(s) of your valid ID and address document',
        label_certificate: 'Photo(s) of your certificate',
        label_address: 'Document confirming your address',
        placeholder: 'Select the type of proof of identity'
      },
      offered_courses: {
        label: 'Which courses do you want to offer?',
        placeholder: 'Choose the courses you want to hold',
        error: {
          required: 'You must choose at least one course template'
        }
      },
      boat_access: {
        label: 'Do you have access by boat to hold the course?',
        placeholder: 'Select yes or no',
        error: {
          required: 'You have to choose yes or no'
        }
      },
      boat_type: {
        label: 'If so, what kind of boat do you have and how much horsepower does it have?',
        placeholder: 'Type of boat and horsepower',
        error: {
          required: 'You must fill in this field if you have answered yes to the question above'
        }
      },
      course_access: {
        label: 'Do you have access to classrooms/course facilities?',
        placeholder: 'Select yes or no',
        error: {
          required: 'You have to choose yes or no'
        }
      },
      pc_access: {
        label: 'I confirm that I have access to a PC with a powerpoint and projector to hold a classroom course'
      },
      notification_preference: {
        label: 'Get a notification if anyone request a course you provide in one of your regions.'
      },
      accept_terms_and_conditions: {
        label: 'I have read and accept the'
      }
    },
    instructions: {
      bank_account_form: {
        stripe_payment_instruction: 'In order for Stripe to make payments to your account, you must provide your full name and IBAN number to the account to which you want payments. Your information is handled securely by Stripe and is not processed by RS Sjøliv.',
        iban_number_instruction_pre_link_text: 'Find your IBAN number by going to',
        iban_number_instruction_link_text: 'this IBAN calculator',
        iban_number_instruction_post_link_text: 'and enter your account number or go to your bank\'s website and search for IBAN number',
      },
      basic_info_form: {
        basic_info_instruction: 'Become part of the RS Sjøliv platform and offer courses! RS delivers platform, course content and markets the courses. RS takes 30% of the course turnover, if no other agreement has been entered into.',
        basic_info_form_fill_up_instruction_initial: 'Before you can start offering courses, you must be approved as an instructor. Fill in all the necessary information in the four steps in the menu on the left to submit an application. The sections must be completed in chronological order.',
        basic_info_form_fill_up_instruction_middle: 'You must have set up your own sole proprietorship in advance to complete this application!',
        basic_info_form_fill_up_instruction_last: 'Once you have been approved by RS admin, you will receive an email with login information to an admin panel, where you can create the courses you want to offer. If any of your documents or information should not be approved, you will be notified by email about the error and further process.',
        contact_instruction: 'If you need help, please contact us at',
        instructor_contact_visibility: 'Your contact information will be available for logged-in users on RS Sjøliv',
        data_collection_info_text: 'We collect this information to build and verify your account. The legal basis for processing under European privacy legislation is found in Article 6 (1b) of the Personal Data Act.',
        form_invalid: 'This field needs to be filled in in order to get to the next step',
        successful_application_info_initial: 'Congratulations, your application has been approved. You are now connected to the RS Sjøliv platform and can offer your courses.',
        successful_application_info_middle_1: 'Log in to the',
        successful_application_info_middle_2: 'to make changes to your profile. If you wish to expand your course offer, please contact',
        successful_application_info_last: 'Please add information about which courses you wish to offer, as well as the necessary documentation for us to be able to approve you as a certified instructor for new courses.',
        admin_web: ' admin panel ',
        basic_application_info_rejected_initial: 'Your application has been rejected.',
        basic_application_info_returned_initial: 'You can still make changes to your application.',
        basic_application_info_returned_middle_1: 'Remember to upload the necessary certificates and CV.',
        contact_customer_center_initial: 'Contact our customer center at',
        contact_customer_center_middle_1: 'or',
        contact_customer_center_middle_2: 'if you need help.',
      },
      identity_verification_form: {
        identity_verification_form_initial: 'In order to receive payments for your courses through RS Sjøliv, our payment provider Stripe must confirm your identity.',
        identity_verification_form_middle: 'Please select the type of proof of identity below and upload photo (s) of a valid proof of identity (only .jpg and .png formats are supported) and a document confirming your address (e.g. electricity or internet bill, signed lease, other documents issued by the authorities ). The images must be of high quality and no larger than 10MB. The address document cannot be older than 6 months and the address must match the one you filled out in the previous step.',
        identity_verification_form_last: 'Your identity documents will be sent directly to Stripe for authentication. RS Sjøliv neither handles nor stores your documents.',
        identity_verification_form_save_instruction:'Press upload and then press save and continue to continue the application.'
      },
      my_courses: {
        cv_and_certificates_upload: 'Please upload your CV and relevant certificates for the courses you want to hold. Your CV should include references from previous employers or course participants.',
        instructor_template_page_link: 'Click here',
        instructor_template_page_info_text: 'to read more about what kind of certifications and courses you need for the different course types.',
        no_cv_and_certificates: 'Please upload at least one CV',
        required_text: 'NB: Fields with asterisk mark must be filled out before submitting the form.'
      }
    },
    action_buttons: {
      back: 'Back',
      next: 'Next',
      update: 'Update',
      save_for_later: 'Save for later',
      upload: 'Upload',
      upload_cv: 'Upload CV',
      upload_certificate: 'Upload Certificate',
      save_and_proceed: 'Save and Proceed',
      send_request: 'Send request'
    },
    tabs: {
      instructor_request: {
        basic_information: 'Basic Information',
        id_verification: 'ID Verification',
        bank_account: 'Bank Account',
        my_courses: 'Courses',
        my_feedbacks: 'Feedbacks'
      }
    },
    feedback_table: {
      id: 'Sr. No',
      created_at: 'Date of Creation',
      description: 'Message',
    },
    card: {
      review: 'Review',
      reviews: 'Reviews',
      one_course: 'course',
      distinct_courses: 'different types of courses'
    },
    or: 'or',
    frontpage: 'FRONT PAGE',
    backpage: 'BACK PAGE',
    terms_and_conditions: 'Terms and Conditions',
    thank_you: 'Thank you for your interest in offering courses at RS Sjøliv!',
    become_an_instructor: 'Become an instructor',
    thank_you_application:'Thank you for your application!',
    instructor_request_success: 'You will soon receive an email confirmation of your application. When your documents and information are processed and approved, you will receive an email with a link to the admin portal where you can create and publish courses.',
    go_to_homepage: 'Go to homepage',
    verified_by: 'Verified by Redningsselskapet',
    name: 'Name',
    email: 'Email',
    phone_number: 'Phone Number',
    read_more: 'Read more',
    read_less: 'Read less',
    reviews: 'reviews',
    review: 'review',
    registration_or_login_prompt: 'Register/Login to contact the instructor'
  },
};
